var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFellowFlorist = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 43,
    viewBox: "0 0 217 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0147 7.7413C18.8951 8.81957 22.5907 14.8376 27.3278 11.1696C32.0648 7.50168 27.9084 -0.811141 19.5955 1.35462C11.2827 3.52038 8.19535 15.4643 21.9272 20.0723C35.659 24.6803 72.9101 30.8919 93.9686 13.6211",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6508 35.9341C25.886 31.7501 31.3695 31.0128 32.7796 33.9987C34.1896 36.9847 32.7796 41.4637 28.2637 41.0213C22.0245 40.4039 20.4117 34.2937 24.6234 28.8101C28.8351 23.3266 38.3552 24.2021 45.2857 24.8657C45.2857 24.8657 25.9321 20.0089 14.1172 29.8239",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9526 13.7734C47.2799 17.0174 51.7957 18.0957 53.215 15.7364C54.6343 13.3771 53.8048 9.53406 50.0631 9.51562C44.8192 9.51562 42.9668 14.4277 45.9897 19.3491C49.0125 24.2704 57.0489 24.3718 62.8273 24.3995C62.8273 24.3995 41.9623 26.1505 34.9766 17.6718",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1507 37.0144C71.2155 35.5767 74.5425 32.4064 76.9939 33.6689C79.4454 34.9315 80.6803 38.7193 77.4271 40.627C72.9204 43.2997 68.8193 39.9911 68.9299 34.1758C69.0405 28.3605 75.8788 24.2594 80.9107 21.2734C80.9107 21.2734 68.4599 22.7203 62.875 32.646",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3398 19.0487C19.3398 19.0487 11.6906 29.5365 1 22.8365C6.56271 19.6763 12.9803 18.3508 19.3398 19.0487Z",
    fill: "#7D3DAE",
    stroke: "#7D3DAE",
    strokeWidth: 0.9216,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6434 25.6016C55.6434 25.6016 52.0676 38.1077 39.7734 35.5548C43.8844 30.6499 49.4379 27.1669 55.6434 25.6016Z",
    fill: "#7D3DAE",
    stroke: "#7D3DAE",
    strokeWidth: 0.9216,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4687 22.1582C75.4687 22.1582 71.4598 9.79038 59.2578 12.7671C63.5386 17.5253 69.2115 20.8117 75.4687 22.1582Z",
    fill: "#7D3DAE",
    stroke: "#7D3DAE",
    strokeWidth: 0.9216,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.982 7.7413C198.093 8.81957 194.406 14.8376 189.66 11.1696C184.914 7.50168 189.08 -0.811141 197.392 1.35462C205.705 3.52038 208.802 15.4643 195.088 20.0723C181.375 24.6803 144.115 30.8919 123.047 13.6211",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.34 35.9341C191.105 31.7501 185.621 31.0128 184.211 33.9987C182.801 36.9847 184.267 41.4637 188.727 41.0213C194.976 40.4039 196.579 34.2937 192.414 28.8101C188.248 23.3266 178.673 24.2021 171.742 24.8657C171.742 24.8657 191.096 20.0089 202.911 29.8239",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M167.047 13.7734C169.71 17.0174 165.203 18.0957 163.784 15.7364C162.365 13.3771 163.185 9.53406 166.936 9.51562C172.171 9.51562 174.032 14.4277 171.009 19.3491C167.987 24.2704 159.95 24.3718 154.172 24.3995C154.172 24.3995 175.028 26.1505 182.013 17.6718",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.84 37.0144C145.784 35.5767 142.448 32.4064 139.996 33.6689C137.545 34.9315 136.31 38.7193 139.554 40.627C144.07 43.2997 148.171 39.9911 148.051 34.1758C147.931 28.3605 141.102 24.2594 136.07 21.2734C136.07 21.2734 148.53 22.7203 154.115 32.646",
    stroke: "#7D3DAE",
    strokeWidth: 1.8432,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.656 19.0506C197.656 19.0506 205.342 29.5384 215.996 22.8752C210.438 19.7023 204.02 18.3639 197.656 19.0506Z",
    fill: "#7D3DAE",
    stroke: "#7D3DAE",
    strokeWidth: 0.9216,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.352 25.6016C161.352 25.6016 164.927 38.1077 177.231 35.5548C173.114 30.6526 167.558 27.1704 161.352 25.6016Z",
    fill: "#7D3DAE",
    stroke: "#7D3DAE",
    strokeWidth: 0.9216,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M141.531 22.1582C141.531 22.1582 145.54 9.79038 157.742 12.7671C153.458 17.5214 147.787 20.8069 141.531 22.1582Z",
    fill: "#7D3DAE",
    stroke: "#7D3DAE",
    strokeWidth: 0.9216,
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFellowFlorist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fellowFlorist.92a516fc9e4a58b56ad32b4b20fc0792.svg";